import React from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'

import './style.css'

const MainNav = ({ onEditor, onSettings, onReports }) => (
  <nav className={cx("main-app-nav", {'main-app-nav-editor--hidden': onEditor})}>
    <Link
      to="/"
      className={cx('main-app-nav-item', { 'main-app-nav-item--active': !onSettings && !onReports })}
    >
      Drift Help
    </Link>
    <Link
      to="/settings"
      className={cx('main-app-nav-item', { 'main-app-nav-item--active': onSettings && !onReports })}
    >
      Settings
    </Link>
    <Link
      to="/reports"
      className={cx('main-app-nav-item', { 'main-app-nav-item--active': onReports && !onSettings })}
    >
      Reports
    </Link>
  </nav>
)

export default MainNav
